/**
 * Internal shared runtime state for the observability subsystem.
 *
 * Kept in its own module so `init.ts` (writes) and `capture.ts` (reads) share
 * exactly one source of truth, and so tests can reset it between cases.
 *
 * BROWSER-SAFE. No server-only imports.
 */
/**
 * The live PostHog client, set by `initObservability` once a key is present.
 * `null` means PostHog is disabled (clean no-op).
 */
let posthogClient = null;
/** Whether Sentry was initialised this session. */
let sentryReady = false;
/** Whether `initObservability` has already run (idempotency guard). */
let initialized = false;
export function setPosthogClient(client) {
    posthogClient = client;
}
export function getPosthogClient() {
    return posthogClient;
}
export function setSentryReady(ready) {
    sentryReady = ready;
}
export function isSentryReady() {
    return sentryReady;
}
export function markInitialized() {
    initialized = true;
}
export function isInitialized() {
    return initialized;
}
/**
 * Reset all observability state. Test-only — not part of the public surface.
 */
export function __resetObservabilityState() {
    posthogClient = null;
    sentryReady = false;
    initialized = false;
}
